const Colors = {
  Red: "Red",
  Blue: "Blue",
};

export default Colors;